import { useEffect, useRef } from 'react';
import { DISABLED_TABS } from '../state/useTabRouter.js';

const TAB_DEFS = [
  { id: 'health', label: 'Health Overview' },
  { id: 'dcma', label: 'DCMA 14-Point' },
  { id: 'findings', label: 'Detailed Findings' },
  { id: 'evm', label: 'EVM', badgeText: 'Phase 2' },
];

/**
 * TabBar — four top-level views. EVM is visible but disabled in Phase A
 * (Phase 2 placeholder). Active tab follows the URL's ?tab= param.
 *
 * Only the "Phase 2" badge on EVM is rendered; the Findings tab does not
 * duplicate the Fix Queue count (which lives in the Fix Queue header).
 *
 * MOBILE-FIT M4 (v3.34): labels never wrap; at narrow widths the strip scrolls
 * horizontally and the active tab is scrolled into view.
 */
export function TabBar({ activeTab, onSelect }) {
  const activeRef = useRef(null);

  useEffect(() => {
    const el = activeRef.current;
    if (el && typeof el.scrollIntoView === 'function') {
      el.scrollIntoView({ block: 'nearest', inline: 'nearest' });
    }
  }, [activeTab]);

  return (
    <div className="tabbar" data-scroll="x" role="tablist" aria-label="Primary views">
      {TAB_DEFS.map((def) => {
        const isActive = def.id === activeTab;
        const disabled = DISABLED_TABS.has(def.id);
        return (
          <button
            key={def.id}
            ref={isActive ? activeRef : undefined}
            type="button"
            role="tab"
            className="tab-btn"
            aria-current={isActive ? 'page' : undefined}
            aria-selected={isActive}
            aria-controls={`panel-${def.id}`}
            aria-disabled={disabled || undefined}
            disabled={disabled}
            onClick={() => !disabled && onSelect(def.id)}
          >
            {def.label}
            {def.badgeText && <span className="tab-badge">{def.badgeText}</span>}
          </button>
        );
      })}
    </div>
  );
}
